import LabelIcon from '@evaneos/b2b-ui/icons/LabelOutlined';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router';

import { DossierId } from '../../../../resources/dossier/types';
import { DefinitionList } from '../../../../design-system/DefinitionList/DefinitionList';
import { useGetDossierData } from '../../../../resources/dossier/queries';
import { useDossierLayoutInfo } from '../../DossierLayoutInfoContext';

import { TagsEditableItem } from './TagsEditableItem';

export function AssociatedTags() {
    const { formatMessage } = useIntl();
    const { dossierId } = useParams<{ dossierId: DossierId }>();
    const { dossier } = useGetDossierData(dossierId) || {};
    const { isFirstColumnNarrow } = useDossierLayoutInfo();

    const dossierTagsLabelId = 'dossier-tags';
    const tags = dossier?.tags || [];

    return (
        <DefinitionList.Item>
            <DefinitionList.Label
                id={dossierTagsLabelId}
                icon={<LabelIcon fontSize="small" aria-hidden="true" />}
                iconOnly={isFirstColumnNarrow}
            >
                {formatMessage({
                    id: 'dossier.closing_confidence.tags.title',
                })}
            </DefinitionList.Label>
            <TagsEditableItem labelId={dossierTagsLabelId} dossierId={dossierId} tags={tags} />
        </DefinitionList.Item>
    );
}
